<template>
  <div id="app">
    <v-app>
      <v-content>
        <template v-if="!logged_in">
          <staff-login
            v-if="adminLogin"
            :changeLogin="changeLogin"
          />
          <login-component
            v-if="!adminLogin"
            :changeLogin="changeLogin"
          />
          <!-- <customer-registration @logged-in="handleLogin" /> -->
        </template>
        <page-container v-if="logged_in"></page-container>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import loginComponent from './components/loginComponent.vue'
import customerRegistration from './components/customerRegistration.vue'
import staffLogin from './components/staffLogin.vue'
import pageContainer from './components/pageContainer.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  name: 'app',
  data() {
    return {
      logged_in: localStorage.getItem('logged_in'),
      url: 'api/login',
      userData: {},
      adminLogin: false
    }
  },

  mounted() {
    if (this.logged_in) {
      this.getUserPermissions(localStorage.getItem('access_token'))
    }

    if (this.$router.currentRoute.fullPath === '/shipzone-admin') {
      this.adminLogin = true
    }
  },

  watch: {
    $route() {
      if (!this.logged_in) {
        this.$router.push('login')
      }
    }
  },

  methods: {
    handleLogin(token) {
      localStorage.setItem('access_token', token)
      this.getUser(localStorage.getItem('access_token'))
      this.getUserPermissions(localStorage.getItem('access_token'))
    },

    changeLogin(loginData) {
      axios
        .post(this.url, loginData)
        .then(response => {
          this.handleLogin(response.data.access_token)
        })
        .catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    getUserPermissions(token) {
      axios
        .get('api/auth_user_permissions', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_permissions', JSON.stringify(response.data))
        })
    },

    getUser(token) {
      axios
        .get('api/me', { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          localStorage.setItem('user_data', JSON.stringify(response.data))
          this.userData = JSON.parse(localStorage.getItem('user_data'))
        })
        .then(() => {
          if (this.userData.is_staff) {
            this.checkExpiredCoupons()
            localStorage.setItem('logged_in', true)
            this.logged_in = localStorage.getItem('logged_in')
            localStorage.setItem('secret_key', false)
          } else {
            console.log('else')
            if (
              !this.userData.phone_number ||
              !this.userData.full_name ||
              !this.userData.email ||
              !this.userData.address
            ) {
              console.log('else -> if')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/')
            } else {
              console.log('else -> else')
              localStorage.setItem('logged_in', true)
              this.logged_in = localStorage.getItem('logged_in')
              this.$router.push('/make-new-order')
            }
          }
          setTimeout(function () {
            location.reload(true)
          }, 1)
        })
    },

    checkExpiredCoupons() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/check_expired_coupons', {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => { })
    }
  },
  components: {
    'login-component': loginComponent,
    'page-container': pageContainer,
    'staff-login': staffLogin,
    customerRegistration
  }
}
</script>
<style>
.ws-nowrap {
  white-space: nowrap !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue